import React from 'react';

type ContextProps = {
  initIndex: string,
    currentIndex: string,
    content: React.ReactNode,
    onSelectTab: (index: string, tab: any) => void
};

const TabContext = React.createContext<Partial<ContextProps>>({});

const useTabContext = () => {
    const context = React.useContext(TabContext);

    if (!context) {
        throw new Error(
          `Dropdown compound components cannot be rendered outside the Dropdown component`,
        )
      }
  
      return context
};

export {
    TabContext,
    useTabContext
}